import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import LocalizationManager from "Engine/base/localization/LocalizationManager";
import RelaxModel from "Base/model/RelaxModel";

export default class BasePopupContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.interactive = true;

        this.init();
        this.initButtons();
        this.addListeners();
        this.addActions();
        this.hide();
    }

    init() {
        this.titleText = this.getChildByName('titleText');
        this.descriptionText = this.getChildByName('descriptionText');
        this.descriptionText.style.wordWrap = true;
        this.descriptionText.style.wordWrapWidth = this.descriptionText.width;
        this.descriptionText.correctPosition(null, 'center');
    }

    initButtons() {
        this.okButton = this.getChildByName('okButton');
        if (this.okButton) {
            this.okButton.enabled = true;
        }

        this.yesButton = this.getChildByName('yesButton');
        if (this.yesButton) {
            this.yesButton.enabled = true;
        }

        this.noButton = this.getChildByName('noButton');
        if (this.noButton) {
            this.noButton.enabled = true;
        }
    }

    addListeners() {
        GlobalDispatcher.add('popupContainer:showPopup', this.onShowPopup, this);
    }

    onShowPopup(event) {
        this.setPopupData(event.params);
        this.show();
    }

    setPopupData(data) {
        switch (data.type) {
            case 'error':
                this.goToFrame(1);
                this.initButtons();
                let identificator = 'error_' + data.data.errorCode;
                this.titleText.text = LocalizationManager.getLocalizedText('error_title');
                let description = LocalizationManager.getLocalizedText(identificator);
                this.descriptionText.text = description === identificator ? data.data.errorMessage : description;
                this.descriptionText.correctPosition(null, 'center');
                this.okButton.actions = {
                    click: {
                        callback: this.onOkErrorClick, context: this,
                    },
                    touchend: {
                        callback: this.onOkErrorClick, context: this,
                    }
                };
                break;
            case 'confirm':
                this.goToFrame(2);
                this.initButtons();
                this.titleText.text = '';
                this.descriptionText.text = LocalizationManager.getLocalizedText(data.message);
                this.descriptionText.correctPosition(null, 'center');
                this.yesButton.actions = {
                    click: {
                        callback: this.onYesClick, context: this, params: {function: data.confirmCallback, context: data.confirmContext}
                    },
                    touchend: {
                        callback: this.onYesClick, context: this, params: {function: data.confirmCallback, context: data.confirmContext}
                    }
                };
                this.noButton.actions = {
                    click: {
                        callback: this.onNoClick, context: this, params: null
                    },
                    touchend: {
                        callback: this.onNoClick, context: this, params: null
                    }
                };
                break;
            default:
                this.goToFrame(1);
                this.initButtons();
                this.titleText.text = LocalizationManager.getLocalizedText(data.title.text, data.title.params);
                this.descriptionText.text = LocalizationManager.getLocalizedText(data.message.text, data.message.params);
                this.descriptionText.correctPosition(null, 'center');
                this.okButton.actions = {
                    click: {
                        callback: this.onOkClick, context: this, params: {function: data.confirmCallback, context: data.confirmContext}
                    },
                    touchend: {
                        callback: this.onOkClick, context: this, params: {function: data.confirmCallback, context: data.confirmContext}
                    }
                };
                break;
        }
    }

    addActions() {
        this.okButton.actions = {
            click: {
                callback: this.onOkClick, context: this,
            },
            touchend: {
                callback: this.onOkClick, context: this,
            }
        };
    }

    onOkClick(data) {
        if (data && data.function) {
            data.function.call(data.context);
        }
        this.hide();
    }

    onOkErrorClick(data) {
        RelaxModel.exitGame();
    }

    onYesClick(data) {
        if (data && data.function) {
            data.function.call(data.context);
        }
        this.hide();
    }

    onNoClick(data) {
        if (data && data.function) {
            data.function.call(data.context);
        }
        this.hide();
    }

    hide() {
        GlobalDispatcher.dispatch('popupContainer:popupHided');
        GlobalDispatcher.dispatch('overlay:hide');
        this.visible = false;
    }

    show() {
        GlobalDispatcher.dispatch('popupContainer:popupShowed');
        GlobalDispatcher.dispatch('overlay:show');
        this.visible = true;
    }
}